import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/ultra.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const switchUltra: Product = {
  id: "switchUltra",
  productTitle: "Ultra",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-ultra"],
  storePathParts: {
    category: "switching-utility",
    collectionSlug: "pro-ultra",
    productSlug: "usw-ultra",
  },
  description: "switchUltra.description.v2",
  descriptionMaxWidth: 140,
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  notes: ["switchUltra.note"],
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '203 x 76 x 33 mm\n(8 x 3 x 1.3")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "8" },
    },
    {
      propertyId: ports.id,
      value: { type: "string", value: "(8) GbE RJ45" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "translation",
        value: "switchUltra.poeAvailability",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "switchUltra.powerMethod",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "switchUltra.mounting",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
